import React from "react";
import ConsumptionOrdersGenericSkeleton from "./ConsumptionOrdersGenericSkeleton";

function ConsumptionOrdersDetailSkeleton() {
  return (
    <>
      <ConsumptionOrdersGenericSkeleton />
    </>
  );
}

export default ConsumptionOrdersDetailSkeleton;
